// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"1106e1a9","703":"ff5270c4"}[chunkId] + ".chunk.js";
};